import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  getAccountBalancesActionsAction,
  getMmLatestTradesAction,
  getMmOrderBookAction,
  getRwaContractBalancesAction,
  getTreasuryTransactionsAction,
} from "./treasury.effects";

export const selectTreasuryState = (state: RootState) => state.treasury;

export const selectAccountBalances = createSelector(
  selectTreasuryState,
  (state) => state.accountBalances || []
);

export const selectIsGetAccountBalancesPending = createSelector(
  selectTreasuryState,
  (state) => state[getAccountBalancesActionsAction.pending.type]
);

export const selectRwaContractBalances = createSelector(
  selectTreasuryState,
  (state) => state.rwaContractBalances
);

export const selectIsGetRwaContractBalancesPending = createSelector(
  selectTreasuryState,
  (state) => state[getRwaContractBalancesAction.pending.type]
);

export const selectTreasuryTransactionsSelectedCategory = createSelector(
  selectTreasuryState,
  (state) => state.selectedTransactionsCategory
);

export const selectTransactionsCategoriesPageSizes = createSelector(
  selectTreasuryState,
  (state) => state.transactionsCategoriesPageSizes
);

export const selectTreasuryTransactions = createSelector(
  selectTreasuryState,
  (state) => state.transactions
);

export const selectIsGetTreasuryTransactionsPending = createSelector(
  selectTreasuryState,
  (state) => state[getTreasuryTransactionsAction.pending.type]
);

export const selectMmOrderBook = (token: string) =>
  createSelector(
    selectTreasuryState,
    (state) => state.mmOrderBook?.[token] || { buy: [], sell: [] }
  );

export const selectIsGetMmOrderBookPending = createSelector(
  selectTreasuryState,
  (state) => state[getMmOrderBookAction.pending.type]
);

export const selectMmLatestTrades = (token: string) =>
  createSelector(
    selectTreasuryState,
    (state) => state.mmLatestTrades?.[token] || []
  );

export const selectIsGetMmLatestTradesPending = createSelector(
  selectTreasuryState,
  (state) => state[getMmLatestTradesAction.pending.type]
);

export const selectMmLatestTradesParams = (token: string) =>
  createSelector(
    selectTreasuryState,
    (state) => state.mmLatestTradesParams[token]
  );
